import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import { useParams } from "react-router-dom/cjs/react-router-dom";

const PaymentStatus = () => {
  const location = useLocation();
  // const params = useParams()
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState({});

  useEffect(() => {
      const checkStatus = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const data = {
            razorpay_payment_id: queryParams.get("razorpay_payment_id"),
            razorpay_payment_link_id: queryParams.get("razorpay_payment_link_id"),
            razorpay_payment_link_status: queryParams.get("razorpay_payment_link_status"),
            razorpay_signature: queryParams.get("razorpay_signature")
        };
    
        setDetails(data);
    
        if (data.razorpay_payment_id && data.razorpay_payment_link_status === "paid") {
          setStatus("success");
        } else {
          setStatus("failed");
        }
    
        // OPTIONAL: Send `data` to backend to verify the signature
        // const res = await axios.post(`${path}/payment/payment-status`, data);
        // if(res.status === 200) {
        //     setStatus("success");
        // } else if(res.status === 400) {
        //     setStatus("inavlid signature");
        // } else {
        //     setStatus("failed");
        // }
    }
    checkStatus()
  }, [location.search]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
      <div className="bg-white shadow-xl rounded-xl p-8 max-w-lg w-full text-center">
        {status === "loading" && <p>Processing payment...</p>}
        {status === "success" && (
          <>
            <h2 className="text-green-600 text-2xl font-bold mb-4">Payment Successful</h2>
            <div className="text-left space-y-2">
              <p><strong>Payment ID:</strong> {details.razorpay_payment_id}</p>
              <p><strong>Payment Link ID:</strong> {details.razorpay_payment_link_id}</p>
              <p><strong>Link Status:</strong> {details.razorpay_payment_link_status}</p>
            </div>
          </>
        )}
        {status === "failed" && (
          <>
            <h2 className="text-red-600 text-2xl font-bold mb-4">Payment Failed or Cancelled</h2>
            <p className="text-gray-600">Please try again or contact support.</p>
          </>
        )}
      </div>
    </div>
  );
}

export default PaymentStatus;
